export default "__VITE_ASSET__CQvrADeL__"